// extracted by mini-css-extract-plugin
export var equalColumn = "_fn-0";